import React from 'react';
import { Input } from '../ui/input';
import { X, Funnel } from '@phosphor-icons/react';
import { EDITABLE_FIELDS, SELECT_FIELDS } from './LeadEditModal';

const BULK_ELIGIBLE_KEYS = ['nome_offerta', 'codice_agenzia', 'codice_agente', 'codice_promozionale', 'fornitore_attuale'];

const BULK_FIELDS = EDITABLE_FIELDS.filter(f => SELECT_FIELDS[f.key] || BULK_ELIGIBLE_KEYS.includes(f.key));

export default function BulkEditPanel({ selectedCount, bulkFields, setBulkFields, onApply, onClose }) {
  return (
    <div className="bg-slate-50 border border-slate-200 rounded-lg p-4 space-y-3" data-testid="bulk-panel">
      <div className="flex items-center justify-between">
        <h3 className="font-semibold text-sm text-slate-700">Modifica Massiva - {selectedCount} leads selezionati</h3>
        <button onClick={onClose} className="text-slate-400 hover:text-slate-600"><X size={18} /></button>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-2">
        {BULK_FIELDS.map(f => (
          <div key={f.key}>
            <label className="text-xs text-slate-500 block mb-1">{f.label}</label>
            {SELECT_FIELDS[f.key] ? (
              <select value={bulkFields[f.key] || ''} onChange={e => setBulkFields(p => ({...p, [f.key]: e.target.value}))}
                className="w-full text-xs border rounded px-2 py-1.5 bg-white">
                {SELECT_FIELDS[f.key].map(o => <option key={o} value={o}>{o || '-- Nessuno --'}</option>)}
              </select>
            ) : (
              <Input value={bulkFields[f.key] || ''} onChange={e => setBulkFields(p => ({...p, [f.key]: e.target.value}))}
                className="text-xs h-8" placeholder={f.label} />
            )}
          </div>
        ))}
      </div>
      <button onClick={onApply}
        className="px-4 py-2 bg-orange-500 hover:bg-orange-600 text-white rounded-md text-sm font-medium"
        data-testid="bulk-apply-btn">
        Applica a {selectedCount} leads
      </button>
    </div>
  );
}
